import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SignupFormComponent } from './signup-form.component';
import { SignupSentComponent } from './components/signup-sent/signup-sent.component';
import { OrganizationExistsComponent } from './components/organization-exists/organization-exists.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { UiComponentsModule } from 'shared/ui-components';
import { FcpButtonModule, FcpFormFieldModule, FcpInputModule } from 'fc-ui-components';
import { OrganizationTypeSelectionModule } from './components/organization-type-selection/organization-type-selection.module';
import { OrganizationInfoFormModule } from './components/organization-info-form';
import { StoreInfoFormModule } from './components/store-info-form';
import { SignupErrorModule } from '../signup-error/signup-error.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        ReactiveFormsModule,
        UiComponentsModule,
        FcpButtonModule,
        OrganizationTypeSelectionModule,
        OrganizationInfoFormModule,
        StoreInfoFormModule,
        FcpFormFieldModule,
        FcpInputModule,
        SignupErrorModule
    ],
    exports: [SignupFormComponent],
    declarations: [SignupFormComponent, SignupSentComponent, OrganizationExistsComponent]
})
export class SignupFormModule {}
